import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { getAdDimensions } from '@openx/components-core/lib/CreativeVideoPreview/imaSdkUtils';
import { PreviewVideo } from '@openx/components-core/lib/CreativeVideoPreview/PreviewVideo';
import { PreviewCloseButton } from './PreviewCloseButton';

type VideoPreviewModalProps = {
  onClose: () => void;
  markupPayload: string;
};

export const VideoPreviewModal = ({ onClose, markupPayload }: VideoPreviewModalProps) => {
  const [width, height] = getAdDimensions();

  return (
    <Modal open onClose={onClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ outline: 'none' }} data-test="video-preview-modal">
        <PreviewVideo adMarkup={markupPayload} onClose={onClose} showControls />
        <PreviewCloseButton onClose={onClose} width={width} height={height} />
      </Box>
    </Modal>
  );
};
